import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    RequestCategory,
    CreateRequestCategoryDto,
    UpdateRequestCategoryDto,
    CreateSubCategoryDto,
    UpdateSubCategoryDto,
    GetRequestCategoriesParams,
    SubjectWithCategory,
    CreateSubjectDto,
    SearchSubcategoriesParams,
} from '../models/request-category.model';

@Injectable({
    providedIn: 'root',
})
export class RequestCategoryService {
    private baseUrl = `${environment.API_GATEWAY_URL}/request-v2/admin/request-category`;

    constructor(private http: HttpClient) {}

    getRequestCategories(params?: GetRequestCategoriesParams): Observable<RequestCategory[]> {
        return this.http.get<RequestCategory[]>(this.baseUrl, { params: params as any });
    }

    getRequestCategoryById(id: string): Observable<RequestCategory> {
        return this.http.get<RequestCategory>(`${this.baseUrl}/${id}/edition`);
    }

    getRequestCategoryForEdition(id: string): Observable<RequestCategory> {
        return this.http.get<RequestCategory>(`${this.baseUrl}/${id}/edition`);
    }

    getAllSubjectsFromCategories(): Observable<SubjectWithCategory[]> {
        return this.http.get<SubjectWithCategory[]>(`${this.baseUrl}/subject/search`);
    }

    getAllSubjectsFromCategoriesUntranslated(): Observable<SubjectWithCategory[]> {
        return this.http.get<SubjectWithCategory[]>(`${this.baseUrl}/subject/search/untranslated`);
    }

    searchSubcategories(params?: SearchSubcategoriesParams): Observable<SubjectWithCategory[]> {
        return this.http.get<SubjectWithCategory[]>(`${this.baseUrl}/subject/search`, { params: params as any });
    }

    createSubject(data: CreateSubjectDto): Observable<SubjectWithCategory> {
        return this.http.post<SubjectWithCategory>(`${this.baseUrl}/subject`, data);
    }

    createRequestCategory(data: CreateRequestCategoryDto): Observable<RequestCategory> {
        return this.http.post<RequestCategory>(this.baseUrl, data);
    }

    updateRequestCategory(id: string, data: UpdateRequestCategoryDto): Observable<RequestCategory> {
        return this.http.patch<RequestCategory>(`${this.baseUrl}/${id}`, data);
    }

    deleteRequestCategory(id: string): Observable<RequestCategory> {
        return this.http.delete<RequestCategory>(`${this.baseUrl}/${id}`);
    }

    createSubCategory(categoryId: string, data: CreateSubCategoryDto): Observable<RequestCategory> {
        return this.http.post<RequestCategory>(`${this.baseUrl}/${categoryId}/sub-category`, data);
    }

    updateSubCategory(categoryId: string, subCategoryId: string, data: UpdateSubCategoryDto): Observable<RequestCategory> {
        return this.http.patch<RequestCategory>(`${this.baseUrl}/${categoryId}/sub-category/${subCategoryId}`, data);
    }

    deleteSubCategory(categoryId: string, subCategoryId: string): Observable<RequestCategory> {
        return this.http.delete<RequestCategory>(`${this.baseUrl}/${categoryId}/sub-category/${subCategoryId}`);
    }

    assignDepartment(categoryId: string, departmentId: string): Observable<RequestCategory> {
        return this.http.post<RequestCategory>(`${this.baseUrl}/${categoryId}/department/${departmentId}`, {});
    }

    unassignDepartment(categoryId: string): Observable<RequestCategory> {
        return this.http.delete<RequestCategory>(`${this.baseUrl}/${categoryId}/department`);
    }
}
